import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Star } from 'lucide-react';

export default function Hero() {
  const { t } = useLanguage();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/zuikrzqv_WhatsApp%20Image%202026-04-17%20at%2012.21.49%20%281%29.jpeg"
          alt="Rui's Restaurante"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 md:px-12 max-w-4xl mx-auto">
        {/* Rating Badge */}
        <div className="inline-flex items-center gap-2 mb-6 opacity-0 animate-fade-in-up">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={16}
                fill={i < 4 ? '#8C5A2B' : 'none'}
                stroke={i < 4 ? '#8C5A2B' : '#8C5A2B'}
                strokeWidth={1.5}
              />
            ))}
          </div>
          <span className="text-[#F0EAE1] text-sm tracking-wider">{t('about.rating')}</span>
        </div>

        {/* Welcome Text */}
        <p className="text-[#E6D8C8] text-sm md:text-base uppercase tracking-[0.3em] mb-4 opacity-0 animate-fade-in-up animation-delay-200">
          {t('hero.welcome')}
        </p>

        {/* Main Title */}
        <h1 className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium text-[#FBF9F6] mb-4 leading-none tracking-tight opacity-0 animate-fade-in-up animation-delay-400">
          Rui's Restaurante
        </h1>

        {/* Subtitle */}
        <p className="font-['Cormorant_Garamond'] text-xl md:text-2xl text-[#E6D8C8] mb-2 italic opacity-0 animate-fade-in-up animation-delay-400">
          {t('hero.subtitle')}
        </p>

        {/* Since */}
        <p className="text-[#8C5A2B] text-sm uppercase tracking-[0.2em] mb-10 opacity-0 animate-fade-in-up animation-delay-400">
          {t('hero.since')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-fade-in-up animation-delay-600">
          <a
            href="#reservations"
            onClick={(e) => scrollToSection(e, '#reservations')}
            data-testid="hero-reserve-btn"
            className="btn-primary inline-flex items-center justify-center"
          >
            {t('hero.cta')}
          </a>
          <a
            href="#menu"
            onClick={(e) => scrollToSection(e, '#menu')}
            data-testid="hero-menu-btn"
            className="bg-transparent text-[#FBF9F6] border border-[#FBF9F6]/50 px-8 py-4 uppercase tracking-[0.1em] text-sm font-medium hover:bg-[#FBF9F6] hover:text-[#2A1E17] transition-all duration-300 inline-flex items-center justify-center"
          >
            {t('hero.viewMenu')}
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-fade-in-up animation-delay-600">
        <div className="w-[1px] h-16 bg-gradient-to-b from-[#FBF9F6]/0 via-[#FBF9F6]/50 to-[#FBF9F6]/0" />
      </div>
    </section>
  );
}
